"use strict";

/**
 * Базовый класс транспорта Агента веб-доступа.
 *
 * @class WebAccess.agent.transport.BaseTransport
 * @since 5.1.0.1500
 */
(function (global) {
  var BaseTransport = BaseObject.extend({
    className: 'BaseTransport',
    name: 'base',
    // Отменен ли запуск агента.
    _isCanceled: false,

    init: function () {
      this._super();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отправляет запрос Агенту веб-доступа.
    * Реализация отправки данных.

    * @method WebAccess.agent.transport.BaseTransport#call
    * @param  {string} requestName Имя запроса
    * @param  {string} pluginName Имя плагина Агента, к которому идет обращение.
    * Для базовых вызовов к ядру Агента веб-доступа передается пустая строка
    * @param  {object} params Параметры запроса
    * @return {object} Результат запроса.
    * @since 5.1.0.1500
    */
    call: function (requestName, pluginName, params) {
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Перезапускает Агент веб-доступа.
    *
    * @method WebAccess.agent.transport.BaseTransport#restart
    * @return {WebAccess.agent.transport.BaseTransport} Объект типа BaseTransport.
    * @since 5.1.0.1511
    */
    restart: function () {
      this._isCanceled = false;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Запускает Агент веб-доступа.
    *
    * @method  WebAccess.agent.transport.BaseTransport#start
    * @return {WebAccess.agent.transport.BaseTransport} Объект типа BaseTransport.
    * @since 5.1.0.1500
    */
    start: function () {
      this._isCanceled = false;
      return this;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Ожидает запуск Агента веб-доступа.
    *
    * @method  WebAccess.agent.transport.BaseTransport#waitForStart
    * @return {Deferred} Специальный deferred-объект.
    * @since 5.1.0.1511
    */
    waitForStart: function (timeout) {
      var me = this;
      var result = $.Deferred();

      var sessionID = '';
      if (typeof g_UserContextID !== "undefined") {
        sessionID = g_UserContextID;
      }

      timeout = timeout || 60000;

      var startTime = $.now();
      var getSessionRegistrationStatus = function () {
        // Если установка отменена - выполнить reject
        if (me._isCanceled) {
          result.reject('canceled');
          return result;
        }

        // Если promise разрешен, проверять статус сессии больше не нужно.
        var state = result.state();
        if (state === 'rejected' || state === 'resolved') {
          return;
        }

        if ($.now() - startTime > timeout) {
          result.reject('timeout');
          return result;
        }

        setTimeout(function () {
          var params = {
            method: 'GetSessionRegistrationStatus',
            SessionID: sessionID
          };
          me._send(params).done(function (doc, method, xhr) {
            var response = xhr.responseText;
            var respObj = $.parseJSON(response);

            if (respObj.success === true) {
              if (respObj.result === 'REGISTERED') {
                log.info('AGENT', 'Session successfully registered by agent');
                result.resolve(true);
              } else if (respObj.result === 'NOTREGISTERED') {
                log.info('AGENT', 'Session registration rejected by agent');
                result.resolve(false);
                WA.agent._showAgentStartedInAnotherSessionDialog();
              }
            } else {
              if (respObj.result == "ERR_INVALID_REQUEST_NAME") { //Уж не знаю правда ли так, но если это убрать то в старом агенте тост будет висеть 1 мин.
                //Агент старой версии, данный метод не поддерживается
                result.reject('oldagent');
              } else {
                getSessionRegistrationStatus();
              }
            }

            return result;
          }).fail(function () {
            getSessionRegistrationStatus();
          });
        }, 200);

        return result;
      };

      setTimeout(function () {
        getSessionRegistrationStatus();
      }, 300); //Небольшая задержка для того что бы URL-схема передала агенту нужную информацию, если он уже был запущен (#93952).

      return result;
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отправляет запрос Агенту веб-доступа.
    * Если при первом запуске веб-доступа Агент не запустился, то запрос не отправляется.
    *
    * @method WebAccess.agent.transport.BaseTransport#transmitRequest
    * @param  {string} requestName Имя запроса
    * @param  {string} pluginName Имя плагина Агента, к которому идет обращение.
    * Для базовых вызовов к ядру Агента веб-доступа передается пустая строка
    * @param  {object} params Параметры запроса
    * @param  {object} extraParams Дополнительные параметры запроса (например, timeout)
    * @return {object} Результат запроса.
    * @since 5.1.0.1500
    */
    transmitRequest: function (requestName, pluginName, params, extraParams) {
      var me = this;

      var d = $.Deferred();

      var sessionID = '';
      if (typeof g_UserContextID !== "undefined") {
        sessionID = g_UserContextID;
        if (params.SessionID == undefined) params["SessionID"] = sessionID || '';
      }

      //переводим параметры в строковые значения
      for (var k in params) {
        params[k] = '' + params[k];
      }

      this.call(requestName, pluginName, params, extraParams).done(function (response) {
        var respObj;

        if (!response) {
          d.reject({ message: "Uknown error", success: false });
          return;
        }
        if (response === "OK") {
          d.resolve({ message: "OK", success: true });
          return;
        }

        if (response === "true") {
          d.resolve({ result: "true", success: true });
          return;
        }

        if (response === "false") {
          d.resolve({ result: "false", success: true });
          return;
        }

        if (response === "PONG") {
          d.resolve({ message: "PONG", success: true });
          return;
        }
        try {
          respObj = $.parseJSON(response);
          try {
            respObj.result = $.parseJSON(respObj.result.replace(/'/g, '"'));
          } catch (_) {
          }
          if (!respObj.success)
            d.reject(respObj);
          d.resolve(respObj);
        } catch (e) {
          log.error(e.message);
          if ($.isPlainObject(respObj) && 'message' in respObj) {
            ShowError(respObj.message);
          } else {
            ShowError(response);
          }
          d.reject(null);
        }
      }).fail(function (response) {
        d.reject({ message: "CONNECTION_NOT_AVAILABLE", success: false });
      });

      return d.promise();
    },
    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//

    /**
    * Отменяет запуск Агента веб-доступа.
    *
    * @since 5.4.0.1006
    */
    cancelStart: function () {
      this._isCanceled = true;
    }
  });

  global.agent.transport.BaseTransport = BaseTransport;

})(window.WebAccess);